import { alpha } from '@mui/material';

import palette from '@/theme/palette';

export const styles = {
  datePicker: {
    'table, thead, tbody, tr, td, th': {
      border: 'none',
      borderCollapse: 'collapse',
    },
    'td, th': {
      width: 'fit-content',
      maxWidth: 'unset',
    },
    'td > button': {
      borderRadius: '50px',
    },
    '.rdp, .rdp-table': {
      margin: 0,
    },

    svg: {
      fill: palette.primary.main,
    },
    '.rdp-range_end': {
      borderTopRightRadius: '50px',
      borderBottomRightRadius: '50px',
    },

    '.rdp-range_start': {
      borderTopLeftRadius: '50px',
      borderBottomLeftRadius: '50px',
    },

    '.rdp-range_end, .rdp-range_start': {
      background: alpha(palette.primary.main, 0.12),
      '.rdp-day_button': {
        fontWeight: 'normal',
        backgroundColor: palette.primary.main,
        borderColor: palette.primary.main,
      },
    },

    '& .rdp-today[data-selected="true"]:not(.rdp-range_middle)': {
      '.rdp-day_button': {
        color: palette.text.contrast,
        fontWeight: 'normal',
        backgroundColor: palette.primary.main,
      },
    },

    '.rdp-today': {
      button: {
        color: palette.primary.main,
        fontWeight: 'bold',
        border: 'none',
      },
    },

    '.rdp-range_middle': {
      backgroundColor: alpha(palette.primary.main, 0.12),
    },

    '.rdp-caption_label': {
      marginLeft: '10px',
      fontWeight: 'normal',
      textTransform: 'capitalize',
    },
  },
};
